import { useCallback, useState } from "react";
import { CandidatiHero } from "@/components/candidati/CandidatiHero";
import { InfrastrutturaCandidati } from "@/components/candidati/InfrastrutturaCandidati";
import { ArchetipiGallery } from "@/components/candidati/archetipi/ArchetipiGallery";
import { ControlloAssoluto } from "@/components/candidati/ControlloAssoluto";
import { CvBuilderCta } from "@/components/candidati/CvBuilderCta";
import { SimFab } from "@/components/candidati/sim/SimFab";
import { SimModal } from "@/components/candidati/sim/SimModal";

export default function Candidati() {
  const [simOpen, setSimOpen] = useState(false);
  const openSim = useCallback(() => setSimOpen(true), []);
  const closeSim = useCallback(() => setSimOpen(false), []);
  return (
    <main data-testid="candidati-page">
      <CandidatiHero />
      <InfrastrutturaCandidati />
      <ArchetipiGallery onOpenSim={openSim} />
      <ControlloAssoluto />
      <CvBuilderCta onOpenSim={openSim} />
      <SimFab onOpen={openSim} />
      {simOpen && <SimModal onClose={closeSim} />}
    </main>
  );
}
